.article {
  padding-block: clamp(38px, 6vw, 68px) clamp(40px, 6vw, 72px);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.back {
  font-size: 14px;
  color: var(--ink-muted);
  align-self: flex-start;
  padding-block: 8px;
}

.back:hover {
  color: var(--ink);
}

.title {
  margin-top: 8px;
  font-size: clamp(34px, 5vw, 48px);
  line-height: 1.1;
  color: var(--ink);
}

.updated {
  font-size: 13px;
  color: var(--ink-muted);
}

.lede {
  margin-top: 10px;
  font-family: var(--font-display);
  font-size: 18px;
  line-height: 1.6;
  color: var(--ink-body);
}

.section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 24px;
  border-top: 1px solid var(--rule);
}

/* The first rule sits a little further from the lede than the rest do from each other. */
.section:first-of-type {
  margin-top: 14px;
}

.sectionTitle {
  font-size: 24px;
  color: var(--ink);
}

.body {
  font-size: 16px;
  line-height: 1.7;
  color: var(--ink-muted);
}

/* Only two sections use a list: what is stored, and which rights apply. Everywhere else
   a paragraph is the house style. */
.points {
  margin: 4px 0 0;
  padding-left: 22px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 16px;
  line-height: 1.7;
  color: var(--ink-muted);
  list-style: disc;
}

.contact {
  margin-top: 26px;
  padding: 20px 22px;
  background: var(--paper-raised);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.contactTitle {
  font-size: 20px;
  color: var(--ink);
}

.contactBody {
  font-size: 16px;
  line-height: 1.7;
  color: var(--ink-body);
}

.contactLine {
  font-size: 16px;
  line-height: 1.6;
  color: var(--ink-body);
}

/* The first fact gets a little air after the sentence above it. Written as a sibling
   selector, not :first-of-type: contactBody is a <p> too and would win that match. */
.contactBody + .contactLine {
  margin-top: 6px;
}

.contactLink {
  font-size: 16px;
  line-height: 1.6;
  color: var(--ink-body);
  text-decoration: underline;
  text-underline-offset: 3px;
  align-self: flex-start;
  padding-block: 8px;
}

.contactLink:hover {
  color: var(--ink);
}

.cross {
  margin-top: 8px;
  font-size: 15px;
  color: var(--ink-muted);
  align-self: flex-start;
  padding-block: 8px;
}

.cross:hover {
  color: var(--ink);
}
